import BeatPrice from './beat-price'
import CartItem from './../classes/CartItem'
import Store from '../store/store'

export default class Beat {
    constructor(data) {
        this.pricing = [];

        for (var i in data) {
            this[i] = data[i];
        }

        this.user = Store.state.user;
        this.activeLicenses = 0;
        this.pricing = this.initPricing(this.pricing);
        this.loadingDownload = false;
        this.inPlayNextList = false
        this.itemId = this.getRandomId()
    }

    static makeArray(data) {
        let beats = [];

        for (var i in data) {
            beats.push(new Beat(data[i]))
        }

        return beats;
    }

    initPricing(pricing) {
        let initPricing = {}

        for (var i = 0; i < this.user.licenses.length; i++) {
            let license = this.user.licenses[i]

            for (var o = 0; o < pricing.length; o++) {
                if (pricing[o].license == license.id) {
                    initPricing[license.id] = new BeatPrice(pricing[o]);
                    if (license.enabled) {
                        this.activeLicenses++
                    }
                    break
                }
            }
        }

        return initPricing;
    }

    getType() {
        return 'beat';
    }

    shareUrl() {
        return `${ab.baseUrl}/beats/${this.alias}`;
    }

    priceRange() {
        let cart = Store.state.cart
        let minPrice = this.minPrice()
        let maxPrice = this.maxPrice()

        if (minPrice > 0 && maxPrice > 0 && minPrice != maxPrice) {
            return `$${cart.formatPrice(minPrice)} - $${cart.formatPrice(maxPrice)}`;
        } else if (minPrice > 0) {
            return `$${cart.formatPrice(minPrice)}`;
        } else if (maxPrice > 0) {
            return `$${cart.formatPrice(maxPrice)}`;
        }

        return '';
    }

    minPrice() {
        let prices = [];

        for (var i in this.pricing) {
            if (this.pricing[i].isSaleable()) prices.push(this.pricing[i].price);
        }

        return (prices.length > 0) ? Math.min(...prices) : 0;
    }

    maxPrice() {
        let prices = [];

        for (var i in this.pricing) {
            if (this.pricing[i].isSaleable()) prices.push(this.pricing[i].price);
        }

        return (prices.length > 0) ? Math.max(...prices) : 0;
    }

    addToCart(license) {
        Store.state.cart.addItem(new CartItem(this, license, this.pricingByLicense(license.id), this.getType()))
    }

    inCart(license = null) {
        return Store.state.cart.inCart(this, license);
    }

    playTag() {
        return !this.tagged;
    }

    pricingByLicense(licenseId) {
        for (var i in this.pricing) {
            if (this.pricing[i].license == licenseId) return this.pricing[i]
        }

        return null;
    }

    orderedPricing() {
        let pricing = _.sortBy(this.pricing, function(o) {
            return o.license.order
        });
        return pricing
    }

    image (size = 100) {
        if (this.artwork && this.artwork.files) {
            return this.artwork.files[size]
        }
        return this.user.avatar.files[size]
    }

    isBeat() {
        return true;
    }

    isSong() {
        return false;
    }

    isSoundKit () {
        return false;
    }

    isCollection() {
        return false;
    }

    play () {
        Store.state.playlistManager.setPagePlaylistToCurrent()

        if (Store.state.playlistManager.getCurrentlyPlaying() &&
            Store.state.playlistManager.getCurrentlyPlaying().id == this.id &&
            Store.state.playlistManager.getCurrentlyPlaying().getType() == this.getType()) {

            Store.state.playlistManager.resume(this)

        } else {

            Store.state.playlistManager.play(this)
        }
    }

    resume () {
        this.play()
    }

    pause () {
        Store.state.playlistManager.pause()
    }

    playNext () {
        Store.state.playlistManager.addToPlayNext(this)
    }

    isPlaying () {
        return (Store.state.playlistManager.isPlaying(this) && Store.state.player.playing)
    }

    getRandomId() {
        let number = Math.random();
        number.toString(36);
        return number.toString(36).substr(2, 9);
    }
}
